module.exports = __webpack_public_path__ + "img/木瓜.6b17a11e.jpg";